import { render, staticRenderFns } from "./edition-cell.vue?vue&type=template&id=04091204&scoped=true"
import script from "./edition-cell.vue?vue&type=script&lang=js"
export * from "./edition-cell.vue?vue&type=script&lang=js"
import style0 from "./edition-cell.vue?vue&type=style&index=0&id=04091204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04091204",
  null
  
)

export default component.exports